import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Whole days left to approve a work log into `payrollRun`, from its
 * `approvalDeadline`.
 *
 * `undefined` when there is nothing to count down to — no run, or a run with no
 * deadline — so callers can fall back to deadline-free copy rather than printing
 * a misleading "0 days".
 */
export const selectorWorkLogApprovalDaysLeft = ({
  payrollRun,
  now = new Date()
}: {
  payrollRun: PayrollRun | undefined;
  now?: Date;
}): number | undefined => {
  const deadline = payrollRun?.approvalDeadline ?? undefined;

  if (!deadline) {
    return undefined;
  }

  return Math.max(
    Math.ceil((deadline.getTime() - now.getTime()) / MS_PER_DAY),
    0
  );
};
